import { t } from '../i18n/index.js';

export function Footer() {
  return `
    <footer class="site-footer">
      <div><a class="brand footer-brand" href="/" data-link><span class="brand-mark">KD</span><span>KIPS <strong>DESIGN</strong></span></a><p>Browser-based 2D + 3D visual space design.</p><a href="mailto:sahidinf@gmail.com">${t('footer.contact')}: sahidinf@gmail.com</a></div>
      <nav aria-label="Legal and support">
        <a href="/about" data-link>${t('nav.about')}</a>
        <a href="/contact" data-link>${t('nav.contact')}</a>
        <a href="/privacy-policy" data-link>Privacy Policy</a>
        <a href="/cookie-policy" data-link>Cookie Policy</a>
        <a href="/terms-of-use" data-link>Terms of Use</a>
        <a href="/disclaimer" data-link>Disclaimer</a>
        <a href="/accessibility" data-link>Accessibility</a>
        <a href="/help" data-link>Help</a>
        <a href="/feedback" data-link>Feedback</a>
        <a href="/sitemap" data-link>Sitemap</a>
      </nav>
      <p class="copyright">${t('footer.rights')}</p>
    </footer>`;
}
